import React from 'react'
import { Container,Navbar } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom';
import { images } from '../'

function Header() {
    let navigate = useNavigate();
    return (
        <Navbar className='py-3 main-top-bar' id='topBar' expand="lg">
            <Container className=''>
                <Navbar.Brand className='' href='#' onClick={() => navigate('/')}>
                    <img
                        src={images.logo}
                        className="d-inline-block align-top img-fluid"
                        alt="Summer-Web Logo"
                    />
                </Navbar.Brand>
            </Container>
        </Navbar>
    )
}

export default Header